import { useState } from "react";
import { pushLocalUserMessage, setRecord, submitUserQuery } from "../store/chatSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import "./Footer.css";

const Footer = () => {
  const dispatch = useAppDispatch();
  const [queryText, setQueryText] = useState("");
  const isTyping = useAppSelector((state) => state.chat.isTyping);
  const isRecording = useAppSelector((state) => state.chat.isRecord);

  const send = async (): Promise<void> => {
    const sanitized = queryText.replace(/<[^>]*>/g, "").trim();
    if (!sanitized) {
      return;
    }
    dispatch(pushLocalUserMessage({ query: sanitized, inputType: "TEXT" }));
    setQueryText("");
    await dispatch(submitUserQuery({ query: sanitized, inputType: "TEXT" }));
  };

  return (
    <>

      {!isTyping ? (
        <div className="section-one">
          <div className="fields">
            <input
              autoComplete="off"
              className="input"
              type="text"
              value={queryText}
              placeholder="Ask any query or use the mic..."
              aria-label="Query textbox"
              onChange={(event) => setQueryText(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  void send();
                }
              }}
            />
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {queryText.length === 0 ? (
                <i
                  className="fa-solid fa-microphone"
                  onClick={() => !isRecording && dispatch(setRecord(true))}
                  style={{
                    color: "var(--primary-color)",
                    fontSize: "clamp(18px, 2vw, 20px)",
                    paddingLeft: "4px",
                    cursor: "pointer"
                  }}
                />
              ) : (
                <i
                  className="fa-solid fa-paper-plane"
                  onClick={() => void send()}
                  style={{
                    color: "var(--primary-color)",
                    fontSize: "clamp(13px, 2vw, 15px)",
                    paddingLeft: "4px",
                    cursor: "pointer"
                  }}
                />
              )}
            </div>
          </div>
        </div>
      ) : null}
      <div className="powered-by fcc">
        Powered by
        <img src="https://askdisha.irctc.co.in/static/media/corover.7f27379178b8dd4508c5.png" alt="" />
      </div>
    </>
  );
};

export default Footer;
